<template>
  <CRow>
    <CCol col="12" lg="12">
      <CAlert color="danger" closeButton :show.sync="dismissCountDown" fade>
        {{ err_msg }}
      </CAlert>

      <CCard>
        <CCardHeader>
          <strong>Add College Profile</strong>
        </CCardHeader>

        <CForm novalidate @submit.prevent="onSubmit">
          <CCardBody>

            <div class="custom-group">
              <label class="custom-label">
                Institute Type *
              </label>

              <div class="radio-wrapper">
                <label class="radio-item">
                  <input
                    type="radio"
                    value="College"
                    v-model="profile.instituteType"
                  />
                  <span>College</span>
                </label><br>

                <label class="radio-item">
                  <input
                    type="radio"
                    value="School"
                    v-model="profile.instituteType"
                  />
                  <span>School</span>
                </label>
              </div>
            </div>

            <!-- Company Information -->

            <div
              class="form-group"
              :class="{ 'form-group--error': $v.profile.companyName.$error }"
            >
              <label class="form__label">
                Institute Name
                <required_span />
              </label>

              <input
                type="text"
                class="form-control"
                placeholder="Institute Name"
                v-model="profile.companyName"
              />

              <small
                class="error"
                v-if="
                  $v.profile.companyName.$error &&
                  !$v.profile.companyName.required
                "
              >
              Institute name is required
              </small>
            </div>

            <CRow>
              <CCol md="6">
                <div
                  class="form-group"
                  :class="{ 'form-group--error': $v.profile.companyEmail.$error }"
                >
                  <label class="form__label">
                    Institute Email
                    <required_span />
                  </label>

                  <input
                    type="email"
                    class="form-control"
                    placeholder="Institute Email"
                    v-model="profile.companyEmail"
                  />

                  <small
                    class="error"
                    v-if="
                      $v.profile.companyEmail.$error &&
                      !$v.profile.companyEmail.required
                    "
                  >
                  Institute email is required
                  </small>
                </div>
              </CCol>

              <CCol md="6">
                <div
                  class="form-group"
                  :class="{ 'form-group--error': $v.profile.location.$error }"
                >
                  <label class="form__label">
                    Location
                    <required_span />
                  </label>

                  <input
                    type="text"
                    id="google-autocomplete"
                    class="form-control"
                    placeholder="Search Location"
                    v-model="profile.location"
                  />

                  <small
                    class="error"
                    v-if="
                      $v.profile.location.$error &&
                      !$v.profile.location.required
                    "
                  >
                    Location is required
                  </small>
                </div>
              </CCol>
            </CRow>

            <div class="form-group">
              <label class="form__label">
                Institute Website
              </label>

              <input
                type="text"
                class="form-control"
                placeholder="Company Website"
                v-model="profile.companyWebsite"
              />
            </div>

            <!-- Admin Information -->

            <h4 class="mt-4 mb-3">
              <strong>Admin Information</strong>
            </h4>

            <div
              class="form-group"
              :class="{ 'form-group--error': $v.profile.adminName.$error }"
            >
              <label class="form__label">
                Admin Name
                <required_span />
              </label>

              <input
                type="text"
                class="form-control"
                placeholder="Admin Name"
                v-model="profile.adminName"
              />

              <small
                class="error"
                v-if="
                  $v.profile.adminName.$error &&
                  !$v.profile.adminName.required
                "
              >
                Admin name is required
              </small>
            </div>

            <CRow>
              <CCol md="6">
                <div class="form-group"
                  :class="{ 'form-group--error': $v.profile.designation.$error }"
                >
                  <label class="form__label">
                    Designation
                    <required_span />
                  </label>

                  <v-select
                    :options="designationOptions"
                    v-model="profile.designation"
                  ></v-select>

                  <small
                    class="error"
                    v-if="
                      $v.profile.designation.$error &&
                      !$v.profile.designation.required
                    "
                  >
                    Designation is required
                  </small>
                </div>
              </CCol>

              <CCol md="6">
                <div
                  class="form-group"
                  :class="{ 'form-group--error': $v.profile.adminEmail.$error }"
                >
                  <label class="form__label">
                    Admin Email
                    <required_span />
                  </label>

                  <input
                    type="email"
                    class="form-control"
                    placeholder="Admin Email"
                    v-model="profile.adminEmail"
                  />

                  <small
                    class="error"
                    v-if="
                      $v.profile.adminEmail.$error &&
                      !$v.profile.adminEmail.required
                    "
                  >
                    Admin email is required
                  </small>
                </div>
              </CCol>
            </CRow>

            <!-- Admin Mobile -->

            <div
              class="form-group"
              :class="{ 'form-group--error': $v.profile.adminMobile.$error }"
            >
              <label class="form__label">
                Admin Mobile Number
                <required_span />
              </label>

              <div class="d-flex">
                <div style="width: 220px; margin-right: 10px;">
                  <v-select
                    :options="countryCodeOptions"
                    v-model="profile.adminCountryCode"
                  ></v-select>
                </div>

                <div style="flex: 1;">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Admin Mobile Number"
                    v-model="profile.adminMobile"
                  />
                </div>
              </div>

              <small
                class="error"
                v-if="
                  $v.profile.adminMobile.$error &&
                  !$v.profile.adminMobile.required
                "
              >
                Admin mobile number is required
              </small>
            </div>
          </CCardBody>

          <CCardFooter>
            <CButton type="submit" size="sm" color="primary">
              <CIcon name="cil-check-circle" />
              Submit
            </CButton>

            &nbsp;

            <CButton color="danger" size="sm" @click="cancel">
              <CIcon name="cil-ban" />
              Cancel
            </CButton>
          </CCardFooter>
        </CForm>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import Vue from "vue";
import VueForm from "vue-form";
import VueNotifications from "vue-notifications";
import VueToasted from "vue-toasted";
import options from "/src/validations/validations.js";
import store from "/src/store/store.js";
import { Mixin } from "/src/mixins/index.js";
import { required, email } from "vuelidate/lib/validators";
import { industry } from "/src/store/url.js";
import required_span from "../../components/layouts/general/required-span";

function toast({ message, type, timeout }) {
  if (type === VueNotifications.types.warn) type = "show";

  return Vue.toasted[type](message, {
    duration: timeout,
    position: "top-left",
  });
}

Vue.use(VueToasted);

const optionss = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast,
};

Vue.use(VueNotifications, optionss);
Vue.use(VueForm, options);

export default {
  name: "CompanyProfileCreate",
  mixins: [Mixin],
  components: {
    required_span,
  },

  data() {
    return {
      err_msg: "",
      dismissCountDown: 0,
      industryOptions: [],
      moduleIndustry: industry,
      designationOptions: [],
      countryCodeOptions: [],
      profile: {
        companyName: "",
        instituteType: "College", // default selected
        companyEmail: "",
        industry: 262,
        location: "",
        city: "",
        state: "",
        country: "",
        latitude: "",
        longitude: "",
        companyWebsite: "",
        companyCountryCode: "",
        adminName: "",
        designation: "",
        adminEmail: "",
        adminCountryCode: "",
        adminMobile: "",
        acceptTerms: false,
      },
    };
  },

  validations: {
    profile: {
      companyName: {
        required,
      },

      companyEmail: {
        required,
        email,
      },

      industry: {
        required,
      },

      location: {
        required,
      },

      adminName: {
        required,
      },

      designation: {
        required,
      },

      adminEmail: {
        required,
        email,
      },

      adminMobile: {
        required,
      },
    },
  },

  async mounted() {
    let self = this;
    store.commit("showLoader", false);
    await this.$gmapApiPromiseLazy();
    this.initAutocomplete();
    axios.get(this.listUrlApi(this.moduleIndustry))
      .then((response) => {
        response.data.data.map(function (value, key) {
          if (value.industryId === "") {
            self.industryOptions.push({ value: value.id, label: value.industry });
          }
        });
      });

    this.designationOptions = [];
    axios
      .post(
        `groups/category-title/dropdown`,{
            "industry": 262
        }
      )
      .then((response) => {

        this.designationOptions =
          response.data.data.map((value) => {

            return {
              value: value.id,
              label: value.title,
            };
          });
      })
      .catch((error) => {

        console.log(error);
      });

    this.countryCodeOptions = [
      { value: "+91", label: "+91" },
    ];

    this.profile.companyCountryCode = this.countryCodeOptions[0];
    this.profile.adminCountryCode = this.countryCodeOptions[0];
  },

  methods: {
    initAutocomplete() {

      const input = document.getElementById(
        "google-autocomplete"
      );

      if (!input || !window.google) return;

      const autocomplete =
        new window.google.maps.places.Autocomplete(input, {
          types: ["geocode"],
          componentRestrictions: { country: "in" },
        });

      autocomplete.addListener("place_changed", () => {

        const place = autocomplete.getPlace();

        this.profile.location =
          place.formatted_address || "";

        if (place.geometry) {

          this.profile.latitude =
            place.geometry.location.lat();

          this.profile.longitude =
            place.geometry.location.lng();
        }

        if (place.address_components) {

          place.address_components.forEach((component) => {

            const types = component.types;

            if (types.includes("locality")) {
              this.profile.city =
                component.long_name;
            }

            if (
              types.includes(
                "administrative_area_level_1"
              )
            ) {
              this.profile.state =
                component.long_name;
            }

            if (types.includes("country")) {
              this.profile.country =
                component.long_name;
            }
          });
        }
        
      });
      },
    onSubmit() {
      this.$v.profile.$touch();

      if (this.$v.profile.$invalid) {
        return;
      }

      const postData = {
        company: this.profile.companyName,
        address1: this.profile.location,
        timezone: "Asia/Calcutta",
        educationInstituteType: this.profile.instituteType,
        skills: "",
        isoCountryShortCode: "IN",
        country: String(this.profile.country || ""),
        state: String(this.profile.state || ""),
        city: String(this.profile.city || ""),
        latitude: String(this.profile.latitude || ""),
        longitude: String(this.profile.longitude || ""),
        countryCode: this.profile.companyCountryCode.value,
        name: this.profile.adminName,
        title: this.profile.designation.label,
        titleId: String(this.profile.designation.value),
        email: this.profile.adminEmail,
        companyEmail: this.profile.companyEmail,
        username: this.profile.adminMobile,
        deviceType: "0",
      };
      let self = this;
      axios
      .post(
        `college-register`,postData
      )
      .then((response) => {
        if (response.status == 200) {
          this.$router.push({
            path: "/education",
          });
        } else {
            self.err_msg = response;
            self.dismissCountDown = 10;
        }
      })
      .catch((error) => {
        self.err_msg = error.response?.data?.message || "Something went wrong.";
        self.dismissCountDown = 10;
      });
    },

    cancel() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.error {
  color: red;
}

.form-group--error label {
  color: red;
}

.form__label {
  font-weight: 600;
}
</style>